module.exports = __webpack_public_path__ + "img/shops.8ec058bd.png";